import { useState } from "react";

export default function ProductSelector({ products, onSubmit }) {
  const [selected, setSelected] = useState([]);
  const [submitted, setSubmitted] = useState(false);

  function toggle(p) {
    setSelected((prev) =>
      prev.includes(p) ? prev.filter((x) => x !== p) : [...prev, p]
    );
  }

  function handleSubmit() {
    if (selected.length === 0 || submitted) return;
    setSubmitted(true);
    onSubmit(selected);
  }

  return (
    <div className="bg-white rounded-2xl py-3 shadow-sm w-full ">
      <p className="text-xs font-semibold text-blue-600 mb-3 uppercase tracking-wide">
        Select your interests (check all that apply)
      </p>

      <div className="space-y-2.5">
        {products.map((p) => (
          <label
            key={p}
            className={`flex items-center gap-3 cursor-pointer rounded-xl px-3 py-2.5 border transition-all duration-150 ${
              selected.includes(p)
                ? "border-blue-400 bg-blue-50"
                : "border-slate-100 hover:border-slate-300 bg-slate-50"
            } ${submitted ? "opacity-50 pointer-events-none" : ""}`}
          >
            <div
              className={`w-4 h-4 rounded flex items-center justify-center border-2 flex-shrink-0 transition-colors ${
                selected.includes(p)
                  ? "bg-blue-600 border-blue-600"
                  : "border-slate-300 bg-white"
              }`}
            >
              {selected.includes(p) && (
                <svg className="w-2.5 h-2.5 text-white" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              )}
            </div>
            <input
              type="checkbox"
              className="sr-only"
              checked={selected.includes(p)}
              onChange={() => toggle(p)}
              disabled={submitted}
            />
            <span className="text-sm text-slate-700 font-medium">{p}</span>
          </label>
        ))}
      </div>

      <button
        onClick={handleSubmit}
        disabled={selected.length === 0 || submitted}
        className="mt-4 w-full py-2.5 rounded-xl text-sm font-semibold transition-all duration-150
          bg-blue-600 text-white hover:bg-blue-700 active:scale-[0.98]
          disabled:bg-slate-200 disabled:text-slate-400 disabled:cursor-not-allowed"
      >
        Continue →
      </button>
    </div>
  );
}